/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAsyncAction } from '../utils/async_utils';
import { FETCH_PERMIT_TYPES } from '../constants/actions';
import { getPermitTypes } from '../api/index';

export const fetchPermitTypes = makeAsyncAction(
    FETCH_PERMIT_TYPES,
    (id: string, active: boolean) => () => getPermitTypes(id, active),
    'permit_types'
);
